import "./common.style.scss";

export interface ControlWrapProps {
    label?: string;
    subLabel?: string;
    testId?: string;
    children: React.ReactNode;
    id: string;
}

export const ControlWrapper = ({label, subLabel, testId, children, id}: ControlWrapProps) => {
    return (
        <div 
            data-testid={`control-wrapper-${testId ? testId : 'test-none'}`}
            className={"control-wrapper"}
        >
            {label && (
                <label htmlFor={id} className="main-label">
                    {label}
                </label>
            )}
            {subLabel && (
                <label htmlFor={id} className="sub-label">
                    {subLabel}
                </label>
            )}
            {children}
        </div>
    )
}